import { format, parse, useDateFnsLocale } from '@if/core/date'
import { Box, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

export const SectionHeader = ({ children }: { children: React.ReactNode }) => (
  <Typography
    variant="subtitle1"
    sx={{
      fontWeight: 'bold',
      marginBottom: 2,
      marginTop: 3,
      marginLeft: 2,
      color: 'primary.main',
      textDecoration: 'underline',
      '@media print': { marginTop: 1, marginBottom: 1 },
    }}
  >
    {children}
  </Typography>
)

export const InfoRow = ({ label, value }: { label: string; value?: string | React.ReactNode }) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'baseline',
      marginBottom: 1,
      marginLeft: 2,
      '@media print': { marginBottom: 0.25 },
    }}
  >
    <Typography
      variant="body2"
      sx={{ width: '180px', flexShrink: 0, color: 'text.secondary', fontWeight: 500 }}
    >
      {label}
    </Typography>
    <Typography
      variant="body2"
      component="div"
      sx={{
        flex: 1,
        borderBottom: '1px solid',
        borderColor: 'divider',
        paddingBottom: '2px',
        fontWeight: 600,
        '@media print': { borderColor: '#999' },
      }}
    >
      {value ?? ''}
    </Typography>
  </Box>
)

export const useFormatFundingDate = () => {
  const { i18n } = useTranslation()
  const { locale } = useDateFnsLocale()

  return (dateStr: string) => {
    try {
      const date = parse(dateStr, 'yyyy-MM-dd', new Date())
      if (i18n.language === 'fr') {
        return format(date, 'd MMMM yyyy', { locale })
      }
      return format(date, 'MMM. d, yyyy', { locale })
    } catch {
      return dateStr
    }
  }
}
